import { onAuthStateChanged } from 'firebase/auth';
import { FC, PropsWithChildren, useCallback, useEffect, useState } from 'react';
import { auth, userCrud } from '@/services/firebase';
import { User as AuthUser } from 'firebase/auth';

import AuthContext from './context';
import { User } from '@/types/database';

const AuthProvider: FC<PropsWithChildren> = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | undefined>();
  const [user, setUser] = useState<User | null>(null);
  const [authUser, setAuthUser] = useState<AuthUser | null>(null);

  const getToken = useCallback(async () => {
    if (authUser) {
      return await authUser.getIdToken();
    }
    return null;
  }, [authUser]);

  useEffect(() => {
    setLoading(true);
    setError(undefined);

    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      if (currentUser) {
        currentUser.getIdToken().then(token => {
          setAuthUser(currentUser);
        });
        userCrud
          .read(currentUser.uid)
          .then((userDoc) => {
            setUser(userDoc as User);
          })
          .catch((err) => setError(err?.message))
          .finally(() => {
            setLoading(false);
          });
      } else {
        setLoading(false);
        setUser(null);
      }
    });

    return () => {
      unsubscribe();
    };
  }, []);

  const authValue = {
    user,
    loading,
    error,
    getToken
  };

  return <AuthContext.Provider value={authValue}>{children}</AuthContext.Provider>;
};

export default AuthProvider;
